"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _localize = require("linksoft/utils/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductIcon = function (_Component) {
    (0, _inherits3.default)(ProductIcon, _Component);

    function ProductIcon() {
        (0, _classCallCheck3.default)(this, ProductIcon);
        return (0, _possibleConstructorReturn3.default)(this, (ProductIcon.__proto__ || (0, _getPrototypeOf2.default)(ProductIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(ProductIcon, [{
        key: "render",
        value: function render() {
            var classes = "product-icon product-icon-" + this.props.iconIdentifier + " product-icon--small";
            return _react2.default.createElement(
                "span",
                { className: classes, "data-toggle": "tooltip",
                    "data-original-title": (0, _localize2.default)(this.props.localizationKey) },
                this.props.text
            );
        }
    }]);
    return ProductIcon;
}(_react.Component);

exports.default = ProductIcon;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/ProductIcon.js
// module id = 907
// module chunks = 0